import Fuse from 'fuse.js';


/**
 *
 */
type SearchListItem = {
	id: number,
	[key: string]: any
};


/**
 *
 */
class SearchUtil
{
	/**
	 *
	 * @see https://fusejs.io/api/options.html#threshold
	 */
	static search( list: SearchListItem[], searchText: string, properties: string[], threshold: number = 0.3, debug: boolean = false )
	{
		const searchPattern = this._searchTextToPattern( searchText );

		if (searchPattern !== '') {

			const options       = {
				useExtendedSearch:  true,
				includeScore:       true,
				includeMatches:     true,
				minMatchCharLength: 2,
				threshold:          threshold,
				ignoreLocation:     true,
				keys:               properties
			};
			const fuse          = new Fuse( list, options );
			const searchResults = fuse.search( searchPattern )
				.filter( result => result.score || 0 <= threshold );

			if (debug) {

				console.log( '--------------- ' + searchPattern );
				searchResults.forEach( result =>
				{
					console.log( '(' + result.item.id + ')', result?.item?.title, Math.round( (result.score || 0) * 1000 ) / 1000 );
				} );
				console.log( searchResults );
				console.log( '---------------' );
			}

			return list.filter( item =>
			{
				return searchResults.some( result => result.item.id === item.id );
			} );
		}

		return list;
	}


	/**
	 * prepare a user-entered search string for Fuse.js extended search
	 *
	 * @see https://fusejs.io/examples.html#extended-search
	 */
	private static _searchTextToPattern( text: string ): string
	{
		const words = text
			.split( /\b/ ) // split by word boundaries
			.map( word => word.replace( /['^|!=$]/g, '' ) ) // remove extended search control characters
			.map( word => word.trim() ) // remove leading/trailing whitespace
			.filter( word => word !== '' ) // remove empty "words"
		;

		return `"${words.join( ' ' )}"`;

		/*

			.filter( word => word !== '' ) // remove empty "words"
			.map( word => `'${word}` )
		;

		return words.join( '|' );
		*/
	}
}


/**
 *
 */
export default SearchUtil;
